import React from 'react';
import BannerSlider from '../components/BannerSlider';
import BookingTab from '../components/BookingTab';
import TripCard from '../components/TripCard';
import CostSlider from '../components/CostSlider';
import TourTypesSlider from '../components/TourTypesSlider';
import MakesSpecial from '../components/MakesSpecial';
import TravelInquiryForm from '../components/TravelInquiryForm';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { Container } from 'react-bootstrap';

function Home() {
  return (
    <div id="home">
      <Header />
      <BannerSlider />
      <BookingTab />

      {/* Favourite Place Section */}
    {/* Heading Section */}
    <div id="tours" className="bg-img">
      <section className="heading-section mt-100 mb-30 plr">
      <Container className="text-center heading-container">
        <h2 className="fw-bolder">
          Most Favorite Tour Place in The Ladakh
        </h2>
        <p className="fw-semibold darkgray-text mb-0 title-paragraph">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry.
        </p>
      </Container>
    </section>
    {/* End Heading Section */}

     <TripCard/>
     </div>

     <div className="sliderBg">
       <CostSlider/>
     </div>
   

  <div id="similar-tours" className="bg-tours pt-50 pb-100">
    <section className="heading-section mb-30 plr">
      <Container className="text-center heading-container">
        <h2 className="fw-bolder">
           Types Of Tours
        </h2>
        <p className="fw-semibold darkgray-text mb-0 title-paragraph">
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry. Lorem Ipsum has been the industry.
        </p>
      </Container>
    </section>

    <TourTypesSlider/>
    
    </div>

   {/* Customize your holiday package with our travel experts Section */}
    
    <div id="inquire-now">
      <TravelInquiryForm/>
    </div>
  
   {/* End Customize your holiday package with our travel experts Section */}

    {/* Customized Holiday Section */}
    <section className="holiday-section d-flex align-items-center justify-content-center mt-100">
      <Container>
        <div className="text-center text-white">
          <h3 className="fw-bold">
            Customize your holiday package with <br /> our travel experts
          </h3>
          <p className="fw-semibold mb-0 title-paragraph">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry.
          </p>
        </div>

        <div className="form-wrapper d-flex justify-content-center align-items-center">
      <form className="d-flex formContainer mt-50">
        <input
          type="text"
          className="form-control fw-semibold"
          placeholder="Enter your Name*"
          required
        />
        <input
          type="email"
          className="form-control fw-semibold"
          placeholder="Enter your Email"
        />
        <input
          type="tel"
          className="form-control fw-semibold"
          placeholder="Enter your Mobile No*"
          required
        />
        <button type="submit" className="btn submit-btn text-white fw-bold">
          Submit
        </button>
      </form>
    </div>
      </Container>
    </section>
 
 {/* Makes us Special Section */}

 <section className="heading-section mt-100 mb-30 plr">
      <Container className="text-center heading-container">
        <h2 className="fw-bolder black-heading">
           What Makes Us Special
        </h2>
        <p className="fw-semibold darkgray-text mb-0 title-paragraph">
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry. Lorem Ipsum has been the industry.
        </p>

        <MakesSpecial/>
      </Container>
  </section>
 
    <div id="contacts">
      <Footer/>
    </div>
    </div>
  );
}
export default Home;
